import { Injectable } from "@angular/core";
import { environment } from "@environment";
import { BehaviorSubject } from "rxjs";
import { LoginService } from "@core/services/login/login.service";

enum PCDCText {
    packaging_charge = 'Packaging',
    delivery_charge = 'Delivery'
}

enum SupportText {
    received = 'Yay! 🥳 Please reach out to us if there are any issues with your order.',
    not_received = 'Oh no! We’re really sorry about that. Please reach out to us and we’ll help you right away.',
    default = ''
}

@Injectable({
    providedIn: "root",
})
export class OrdersUtilService {
    DEPLOY_URL: string;
    customerOrdersState = new BehaviorSubject<any>(null);
    deliveryInfoObserver = new BehaviorSubject<any>({});
    activeRefundCount = new BehaviorSubject<number>(null);

    constructor(
        private loginService: LoginService
    ) {
        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.loginService.userLogoutSuccess
            .subscribe(() => {
                this.customerOrdersState.next(null);
                this.activeRefundCount.next(null);
            });
    }

    getOrderStatusIcon(customerOrders: any) {
        let orderStatusIcon = {};
        customerOrders.forEach((order: any) => {
            switch (order.order_status.status) {
                case "cancelled": {
                    orderStatusIcon[order.order_details.id] = `${this.DEPLOY_URL}/assets/images/order-cancelled.svg`;
                    return;
                }
                case "delivered":
                case "settled": {
                    orderStatusIcon[order.order_details.id] = `${this.DEPLOY_URL}/assets/images/order-delivered.svg`;
                    return;
                }
                default: {
                    orderStatusIcon[order.order_details.id] = `${this.DEPLOY_URL}/assets/images/order-preparing.svg`;
                    return;
                }
            }
        });
        return orderStatusIcon;
    }

    getPCDCtext(order_details) {
        let text = [];
        const { bill_details } = order_details;
        for(let i = 0; i < bill_details.length; i++) {
            if(['packaging_charge', 'delivery_charge'].indexOf(bill_details[i].type) >= 0 && !bill_details[i].amount) {
                if (text.length === 1) {
                    text.push('/');
                }
                text.push(PCDCText[bill_details[i].type]);
            }
        }
        if(text.length) {
            text.push('Fees');
        }
        return text.join(' ');
    }

    deliveryConfirmationStatus(order) {
        let response = order.delivery_confirmation.response;
        switch(response) {
            case true:
                return SupportText['received'];
            case false:
                return SupportText['not_received'];
            default:
                return SupportText['default'];
        }
    }

    showDeliveryConfirmation(order) {
        let response = order.delivery_confirmation.response === undefined;
        let isOrderDelivered = order.order_status.status === 'delivered';
        let THIRTY_MINUTES = 30 * 60 * 1000;
        let currentTime = Date.now();
        let timeElapsed = (currentTime - order.order_status.updated_at * 1000) < THIRTY_MINUTES; //difference less than 30mins
        if(response && isOrderDelivered && timeElapsed) {
            return true;
        } else {
            return false;
        }
    }

    selectDeliveryStatus(order: any, value: boolean | undefined) {
        order.delivery_confirmation.response = value;
        return this.deliveryConfirmationStatus(order);
    }

    getDeliveryConfirmationStatus(order: any, value: boolean | undefined) {
        const showDeliveryConfirmation = value !== undefined ? false : this.showDeliveryConfirmation(order);
        const HelpNSupportText = order.delivery_confirmation.response !== undefined ? SupportText['default'] : this.selectDeliveryStatus(order, value);
        this.deliveryInfoObserver.next({
            showDeliveryConfirmation,
            HelpNSupportText
        });
    }
}
